import React from 'react';
import PropTypes from 'prop-types';
import { ToolOutlined } from '@ant-design/icons';

export default function EquipmentRowAvatar({ className }) {
  return (
    <span className={`schedule-equipment-axis-avatar${className ? ` ${className}` : ''}`}>
      <ToolOutlined />
    </span>
  );
}

EquipmentRowAvatar.propTypes = {
  className: PropTypes.string,
};

EquipmentRowAvatar.defaultProps = {
  className: undefined,
};
